import * as Icon from 'base/ui/components/Icons';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ThemeConfig from './changeTheme';
import {
  commonPresenter,
  commonStore,
  homePresenter,
  homeStore,
  languagePresenter,
  languageStore,
  uiPresenter,
  uiStore,
} from 'stores/root_store';
import './dashboard.css';
import CollapseWrapper from 'base/ui/components/CustomCollapse';
import CustomPie from 'base/ui/components/CustomChart/PieChart';
import CustomBar from 'base/ui/components/CustomChart/BarChart';
import CustomBarRace from 'base/ui/components/CustomChart/BarRaceChart';
import CustomMixedLineAndBar from 'base/ui/components/CustomChart/MixedLineAndBar';
import CardDashBoard from './cardDashBoard';
import CustomSelect from 'base/ui/components/CustomSelect';
import { chartPresenter } from 'stores/root_store';
import { chartStore } from 'stores/root_store';
import { ArrayTotalCustomerModel, ValueCustomerModel } from 'services/Main/chart_services';
import { ValueModel, ValueNewsModel, ValueTaskModel } from 'services/Main/home_services';
import { sFormatNumber } from 'utils/formatHelper';
import { MVC_URL } from 'utils/constants';
import { ChartType } from 'base/ui/components/CustomChart/models';
import { BaseModel } from 'services/Main/common_services';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { getIsChatBox, getIsShowChooseModule, getIsShowDashboard, getUserSession } from 'utils/localStorageHelper';
import { ModuleModel, User } from 'services/User/user_services';
import { LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
//
const valueName = ['Point', 'Case'];

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "zapier-interfaces-chatbot-embed": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export function createDashboard() {
  return observer(() => {
    document.title = 'Trang chủ - iCRM System';
    // Thêm script Zapier vào head khi dashboard mount
    useEffect(() => {
      const script = document.createElement('script');
      script.async = true;
      script.type = 'module';
      script.src = 'https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js';
      document.head.appendChild(script);
      return () => {
        document.head.removeChild(script);
      };
    }, []);

    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    //=====================================CHECK PHÂN QUYỀN=====================================//
    const isShowChooseModule = getIsShowChooseModule()
    const isShowDashboard = getIsShowDashboard()
    //=====================================CHART=====================================//
    // Lấy data tỉ lệ khách hàng theo loại
    const [listCustomerType, setListCustomerType] = useState<ValueCustomerModel[]>([]);
    // Lấy data tỉ lệ khách hàng theo nhóm
    const [listPercentCustomerGroup, setListPercentCustomerGroup] = useState<ValueCustomerModel[]>([]);
    // Lấy data số lượng nhóm khách hàng theo nhóm
    const [listNumberCustomerGroup, setListNumberCustomerGroup] = useState<ArrayTotalCustomerModel>();
    // Lấy data tỉ lệ khách hàng theo khu vực
    const [listPercentCustomerSaleOffice, setListPercentCustomerSaleOffice] = useState<ValueCustomerModel[]>([]);
    // Lấy data số lượng khách hàng theo khu vực
    const [listNumberCustomerSaleOffice, setListNumberCustomerSaleOffice] = useState<ArrayTotalCustomerModel>();
    // Lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
    const [listTop10CustomerProvince, setListTop10CustomerProvince] = useState<ChartType[]>([]);
    // Lấy data số lượng khách hàng thăm npp/srnq tháng này và tháng trước
    const [listCustomerVisitingDistributers, setListCustomerVisitingDistributers] = useState<ChartType[][]>([]);
    //Lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
    const [listCustomerVisitingShowroom, setListCustomerVisitingShowroom] = useState<ChartType[][]>([]);
    // Lấy data tổng hợp điểm trưng bày
    const [listShowroom, setListShowroom] = useState<ChartType[][]>([]);
    // Lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
    const [listProductIssueGroup, setListProductIssueGroup] = useState<ChartType[][]>([]);
    // Lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
    const [listProductIssueError, setListProductIssueError] = useState<ChartType[][]>([]);
    // Lấy data tổng hợp xuất nhập tồn catalog
    const [listCatalog, setListCatalog] = useState<ChartType[]>([]);
    // Lấy data thị hiếu khách hàng đến showroom
    const [listCustomerTastes, setListCustomerTastes] = useState<ChartType[]>([]);
    // Lấy data tổng hợp thị hiếu sản phẩm
    const [listStatisticLikeView, setListStatisticLikeView] = useState<ChartType[]>([]);
    //=====================================HOME=====================================//
    // Lấy danh sách common date
    const [listSelectCommonDate, setListSelectCommonDate] = useState<BaseModel[]>();
    // Lấy data common date đã chọn
    const [selectCommonDate, setSelectCommonDate] = useState<string>('ThisMonth');
    // Lấy data bảng thông tin - tổng khách hàng
    const [listCountCustomer, setListCountCustomer] = useState<ValueModel[]>([]);
    // Lấy data bảng thông tin - tổng liên hệ
    const [listCountContact, setListCountContact] = useState<ValueModel[]>([]);
    // Lấy data bảng thông tin - tổng công việc
    const [listCountTask, setListCountTask] = useState<ValueModel[]>([]);
    // Lấy data bảng thông tin - công việc được phân công
    const [listCountTaskToDo, setListCountTaskToDo] = useState<ValueModel[]>([]);
    // Lấy data bảng thông tin - công việc đang thực hiện
    const [listCountTaskProcessing, setListCountTaskProcessing] = useState<ValueModel[]>([]);
    // Lấy data bảng thông tin - công việc đã quá hạn
    const [listCountTaskExpired, setListCountTaskExpired] = useState<ValueModel[]>([]);
    // Lấy data bảng thông tin - công việc đã hoàn thành
    const [listCountTaskCompleted, setListCountTaskCompleted] = useState<ValueModel[]>([]);
    // Lấy data cập nhật hoạt động - số lượng ghé thăm
    const [listCountVisiting, setListCountVisiting] = useState<ValueModel[]>([]);
    // Lấy data cập nhật hoạt động - thăm hỏi khách hàng
    const [listCountVisitingCustomer, setListCountVisitingCustomer] = useState<ValueModel[]>([]);
    // Lấy data cập nhật hoạt động - nhiệm vụ khác
    const [listCountActivities, setListCountActivities] = useState<ValueModel[]>([]);
    // Lấy data bảng tin
    const [listNewsView, setListNewsView] = useState<ValueNewsModel[]>([]);
    // Lấy data thông tin cập nhật
    const [listUpdateInformation, setListUpdateInformation] = useState<ValueTaskModel>();

    // ==================================== LOADING =================================
    const [listLoading, setListLoading] = useState({
      // -----------CHART --------------------------------
      // Tỉ lệ khách hàng theo loại
      chartTiLeKHTheoLoai: true,
      // Tỉ lệ khách hàng theo nhóm
      chartTiLeKHTheoNhom: true,
      // Số lượng khách hàng theo nhóm
      chartSLNhomKHTheoNhom: true,
      // Top 10 tỉnh thành có số lượng khách hàng cao nhất
      chartTop10TinhCoKHCaoNhat: true,
      // Tỉ lệ khách hàng theo khu vực
      chartTiLeKHTheoKhuVuc: true,
      // Số lượng khách hàng theo khu vực
      chartSLKHTheoKhuVuc: true,
      // Số lượng KH thăm npp/srnq tháng này và tháng trước
      chartSLKHThamNPP: true,
      // Số lượng KH thăm showroom tháng này và tháng trước
      chartSLKHThamShowroom: true,
      // Tổng hợp thị hiếu sản phẩm
      chartTongHopThiHieuSP: true,
      // Tổng hợp điểm trưng bày
      chartTongHopDiemTrungBay: true,
      // Tổng hợp xử lý khiếu nại theo nhóm hàng
      chartTHXuLyKhieuNaiTheoNhom: true,
      // Tổng hợp xử lý lỗi thường gặp
      chartTHXuLyKhieuNaiLoi: true,
      // Thị hiếu khách hàng đến showroom
      chartTHKHDenShowroom: true,
      // Tổng hợp xuất nhập tồn catalog
      chartTonCatalog: true,
      // -----------------------THÔNG TIN CẬP NHẬT-----------------------------
      thongTinCapNhat: true,
      //  ---------------------- BẢNG TIN ------------------------
      bangTin: true,
      //  ---------------------- CÔNG VIỆC PHÂN CÔNG  ------------------------
      congViecPhanCong: true,
    });

    //==================================GET DATA CHART==================================//

    // Hàm lấy data tỉ lệ khách hàng theo loại
    const getListCustomerType = async (companyCode: string) => {
      await chartPresenter.getListCustomerType(chartStore, companyCode);
      if (chartStore.listCustomerTypeResponse.isSuccess) {
        setListCustomerType(chartStore.listCustomerTypeResponse.data);
      }
    };
    // Hàm lấy data tỉ lệ khách hàng theo nhóm
    const getListPercentCustomerGroup = async (companyCode: string) => {
      await chartPresenter.getlListPercentCustomerGroup(chartStore, companyCode);
      if (chartStore.listPercentCustomerGroupResponse.isSuccess) {
        setListPercentCustomerGroup(chartStore.listPercentCustomerGroupResponse.data);
      }
    };
    // Hàm lấy data số lượng nhóm khách hàng theo nhóm
    const getListNumberCustomerGroup = async (companyCode: string) => {
      await chartPresenter.getListNumberCustomerGroup(chartStore, companyCode);
      if (chartStore.listNumberCustomerGroupResponse.isSuccess) {
        const apiResult = chartStore.listNumberCustomerGroupResponse.data;
        const name: string[] = [];
        const total: number[] = [];

        apiResult.forEach((item) => {
          name.push(item.name);
          total.push(item.total);
        });

        setListNumberCustomerGroup({ name: name, total: total });
      }
    };
    // Hàm lấy data tỉ lệ khách hàng theo khu vực
    const getListPercentCustomerSaleOffice = async (companyCode: string) => {
      await chartPresenter.getListPercentCustomerSaleOffice(chartStore, companyCode);
      if (chartStore.listPercentCustomerSaleOfficeResponse.isSuccess) {
        setListPercentCustomerSaleOffice(chartStore.listPercentCustomerSaleOfficeResponse.data);
      }
    };
    // Hàm lấy data số lượng khách hàng theo khu vực
    const getListNumberCustomerSaleOffice = async (companyCode: string) => {
      await chartPresenter.getListNumberCustomerSaleOffice(chartStore, companyCode);
      if (chartStore.listNumberCustomerSaleOfficeResponse.isSuccess) {
        const apiResult = chartStore.listNumberCustomerSaleOfficeResponse.data;
        const name: string[] = [];
        const total: number[] = [];

        apiResult.forEach((item) => {
          name.push(item.name);
          total.push(item.total);
        });

        setListNumberCustomerSaleOffice({ name: name, total: total });
      }
    };
    // Hàm lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
    const getListTop10CustomerProvince = async (companyCode: string) => {
      await chartPresenter.getListTop10CustomerProvince(chartStore, companyCode);
      if (chartStore.listTop10CustomerProvinceResponse.isSuccess) {
        const apiResult = chartStore.listTop10CustomerProvinceResponse.data;
        const result = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.customer-number'),
            label: item.name,
            value: item.total,
          };
        });

        setListTop10CustomerProvince(result);
      }
    };
    // Hàm lấy data số lượng khách hàng thăm npp/srnq tháng này và tháng trước
    const getListCustomerVisitingDistributers = async (companyCode: string) => {
      await chartPresenter.getListCustomerVisitingDistributers(chartStore, companyCode);
      if (chartStore.listCustomerVisitingDistributersResponse.isSuccess) {
        const apiResult = chartStore.listCustomerVisitingDistributersResponse.data;
        const dataNow = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.this-month'),
            label: item.name,
            value: item.totalNow,
          };
        });
        const dataPrevious = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.last-month'),
            label: item.name,
            value: item.totalPrevious,
          };
        });
        const result = [dataNow, dataPrevious];

        setListCustomerVisitingDistributers(result);
      }
    };
    //Hàm lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
    const getListCustomerVisitingShowroom = async (companyCode: string) => {
      await chartPresenter.getListCustomerVisitingShowroom(chartStore, companyCode);
      if (chartStore.listCustomerVisitingShowroomResponse.isSuccess) {
        const apiResult = chartStore.listCustomerVisitingShowroomResponse.data;
        const dataNow = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.this-month'),
            label: item.name,
            value: item.totalNow,
          };
        });
        const dataPrevious = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.last-month'),
            label: item.name,
            value: item.totalPrevious,
          };
        });
        const result = [dataNow, dataPrevious];

        setListCustomerVisitingShowroom(result);
      }
    };
    // Hàm lấy data tổng hợp điểm trưng bày
    const getListShowroom = async (companyCode: string) => {
      await chartPresenter.getListShowroom(chartStore, companyCode);
      if (chartStore.listShowroomResponse.isSuccess) {
        const apiResult = chartStore.listShowroomResponse.data;
        const dataNow = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.qty'),
            label: item.name,
            value: item.totalCol,
          };
        });
        const dataPrevious = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.value'),
            label: item.name,
            value: item.totalLine,
          };
        });
        const result = [dataNow, dataPrevious];

        setListShowroom(result);
      }
    };
    // Hàm lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
    const getListProductIssueGroup = async (companyCode: string) => {
      await chartPresenter.getListProductIssueGroup(chartStore, companyCode);
      if (chartStore.listProductIssueGroupResponse.isSuccess) {
        const apiResult = chartStore.listProductIssueGroupResponse.data;
        const dataCase = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.warranty-number'),
            label: item.name,
            value: item.totalCol,
          };
        });
        const dataValue = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.warranty-value'),
            label: item.name,
            value: item.totalLine,
          };
        });
        const result = [dataCase, dataValue];

        setListProductIssueGroup(result);
      }
    };
    // Hàm lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
    const getListProductIssueError = async (companyCode: string) => {
      await chartPresenter.getListProductIssueError(chartStore, companyCode);
      if (chartStore.listProductIssueErrorResponse.isSuccess) {
        const apiResult = chartStore.listProductIssueErrorResponse.data;
        const dataCase = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.warranty-number'),
            label: item.name,
            value: item.totalCol,
          };
        });
        const dataValue = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.warranty-value'),
            label: item.name,
            value: item.totalLine,
          };
        });
        const result = [dataCase, dataValue];

        setListProductIssueError(result);
      }
    };
    // Hàm lấy data tổng hợp xuất nhập tồn catalog
    const getListCatalog = async (companyCode: string) => {
      await chartPresenter.getListCatalog(chartStore, companyCode);
      if (chartStore.listCatalogResponse.isSuccess) {
        const apiResult = chartStore.listCatalogResponse.data;
        const result = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.customer-number'),
            label: item.name,
            value: item.total,
          };
        });

        setListCatalog(result);
      }
    };
    // Hàm lấy data thị hiếu khách hàng đến showroom
    const getListCustomerTastes = async (companyCode: string) => {
      await chartPresenter.getListCustomerTastes(chartStore, companyCode);
      if (chartStore.listCustomerTastesResponse.isSuccess) {
        const apiResult = chartStore.listCustomerTastesResponse.data;
        const result = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.customer-number'),
            label: item.name,
            value: item.total,
          };
        });

        setListCustomerTastes(result);
      }
    };
    // Hàm lấy data tổng hợp thị hiếu sản phẩm
    const getListStatisticLikeView = async (companyCode: string) => {
      await chartPresenter.getListStatisticLikeView(chartStore, companyCode);
      if (chartStore.listStatisticLikeViewResponse.isSuccess) {
        const apiResult = chartStore.listStatisticLikeViewResponse.data;
        const result = apiResult.map((item) => {
          return {
            name: t('dashboard.chart.customer-number'),
            label: item.name,
            value: item.total,
          };
        });

        setListStatisticLikeView(result);
      }
    };
    //==================================GET DATA HOME==================================//
    //Hàm lấy danh sách common date
    const getListSelectCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        const apiResult = commonStore.commonRespone.data;
        const result = apiResult.map((item) => {
          return {
            label: item.value,
            value: item.key,
          };
        });
        setListSelectCommonDate(result);
      }
    };
    // Hàm lấy common date đã chọn từ thẻ select
    const handleSelectCommonDate = (value: string) => {
      setSelectCommonDate(value);
    };
    // Hàm lấy data bảng thông tin - tổng khách hàng
    const getListCountCustomer = async () => {
      await homePresenter.getListCountCustomer(homeStore);
      if (homeStore.listCountCustomerResponse.isSuccess) {
        setListCountCustomer(homeStore.listCountCustomerResponse.data);
      }
    };
    // Hàm lấy data bảng thông tin - tổng liên hệ
    const getListCountContact = async () => {
      await homePresenter.getListCountContact(homeStore);
      if (homeStore.listCountContactResponse.isSuccess) {
        setListCountContact(homeStore.listCountContactResponse.data);
      }
    };
    // Hàm lấy data bảng thông tin - tổng công việc
    const getListCountTask = async () => {
      await homePresenter.getListCountTask(homeStore);
      if (homeStore.listCountTaskResponse.isSuccess) {
        setListCountTask(homeStore.listCountTaskResponse.data);
      }
    };
    // Hàm lấy data bảng thông tin - công việc được phân công
    const getListCountTaskToDo = async (employeeCode: string) => {
      await homePresenter.getListCountTaskToDo(homeStore, employeeCode);
      if (homeStore.listCountTaskToDoResponse.isSuccess) {
        setListCountTaskToDo(homeStore.listCountTaskToDoResponse.data);
      }
    };
    // Hàm lấy data bảng thông tin - công việc đang thực hiện
    const getListCountTaskProcessing = async (employeeCode: string) => {
      await homePresenter.getListCountTaskProcessing(homeStore, employeeCode);
      if (homeStore.listCountTaskProcessingResponse.isSuccess) {
        setListCountTaskProcessing(homeStore.listCountTaskProcessingResponse.data);
      }
    };
    // Hàm lấy data bảng thông tin - công việc đã quá hạn
    const getListCountTaskExpired = async (employeeCode: string) => {
      await homePresenter.getListCountTaskExpired(homeStore, employeeCode);
      if (homeStore.listCountTaskExpiredResponse.isSuccess) {
        setListCountTaskExpired(homeStore.listCountTaskExpiredResponse.data);
      }
    };
    // Hàm lấy data bảng thông tin - công việc đã hoàn thành
    const getListCountTaskCompleted = async (employeeCode: string) => {
      await homePresenter.getListCountTaskCompleted(homeStore, employeeCode);
      if (homeStore.listCountTaskCompletedResponse.isSuccess) {
        setListCountTaskCompleted(homeStore.listCountTaskCompletedResponse.data);
      }
    };
    // Hàm lấy data cập nhật hoạt động - số lượng ghé thăm
    const getListCountVisiting = async (selectedCommonDate: string) => {
      await homePresenter.getListCountVisiting(homeStore, selectedCommonDate);
      if (homeStore.listCountVisitingResponse.isSuccess) {
        setListCountVisiting(homeStore.listCountVisitingResponse.data);
      }
    };
    // Hàm lấy data cập nhật hoạt động - thăm hỏi khách hàng
    const getListCountVisitingCustomer = async (selectedCommonDate: string) => {
      await homePresenter.getListCountVisitingCustomer(homeStore, selectedCommonDate);
      if (homeStore.listCountVisitingCustomerResponse.isSuccess) {
        setListCountVisitingCustomer(homeStore.listCountVisitingCustomerResponse.data);
      }
    };
    // Hàm lấy data cập nhật hoạt động - nhiệm vụ khác
    const getListCountActivities = async (selectedCommonDate: string) => {
      await homePresenter.getListCountActivities(homeStore, selectedCommonDate);
      if (homeStore.listCountActivitiesResponse.isSuccess) {
        setListCountActivities(homeStore.listCountActivitiesResponse.data);
      }
    };
    // Hàm lấy data bảng tin
    const getListNewsView = async (accountId: string) => {
      await homePresenter.getListNewsView(homeStore, accountId);
      if (homeStore.listNewsViewResponse.isSuccess) {
        setListNewsView(homeStore.listNewsViewResponse.data);
      }
    };
    // Hàm lấy data thông tin cập nhật
    const getListUpdateInformation = async () => {
      await homePresenter.getListUpdateInformation(homeStore);
      if (homeStore.listUpdateInformationResponse.isSuccess) {
        setListUpdateInformation(homeStore.listUpdateInformationResponse.data);
      }
    };

    //===========================LOAD DATA===========================//
    // đổi ngôn ngữ từ mvc
    // mcv baasms đổi ngôn ngữ thì get đường link với định dạng (?lang=en&returnurl=http://localhost:54103/Work/Task?Type=THKH)
    // Trong đó `lang` là ngôn ngữ , `returnurl` là đường dẫn quay lại trang mvc trước đó
    // Kiểm tra xem trên url có parameter hay không (nếu có là bên mvc đang thay đổi ngôn ngữ) => việc cần làm là thay đổi ngôn ngữ bên web của mình
    // Sau đó quay ngược lại trang mvc bằng `returnurl`
    const translateLanguage = async () => {
      // Kiểm tra parameter
      if (searchParams.get('lang')) {
        // cập nhật ngôn ngữ ở local storage
        uiPresenter.setLanguage(uiStore, searchParams.get('lang') || 'vi');
        // Cập nhật lại menu
        await languagePresenter.translateLanguage(languageStore, searchParams.get('lang') || 'vi');
        window.location.assign(searchParams.get('returnurl') || '/');
      }
    };

    useEffect(() => {
      uiPresenter.resetSubmenuOpen(uiStore)
      const data = JSON.parse(localStorage.getItem('user_session') || '{}');
      const plantCode = data.plantCode;
      const accountId = data.accountId;
      // const selectOrg = JSON.parse(localStorage.getItem('selectOrg') || '{}');
      const employeeCode = data.employeeCode ? data.employeeCode : '0';
      const loadData = async () => {
        const loading = { ...listLoading };
        //============BẢNG THÔNG TIN============//
        getListCountCustomer();
        getListCountContact();
        getListCountTask();
        //================CHART================//
        // Tỉ lệ khách hàng theo loại
        (async () => {
          await getListCustomerType(plantCode);
          loading.chartTiLeKHTheoLoai = false;
          setListLoading({ ...loading });
        })();
        // Tỉ lệ khách hàng theo nhóm
        (async () => {
          await getListPercentCustomerGroup(plantCode);
          loading.chartTiLeKHTheoNhom = false;
          setListLoading({ ...loading });
        })();

        // Số lượng khách hàng theo
        (async () => {
          await getListNumberCustomerGroup(plantCode);
          loading.chartSLNhomKHTheoNhom = false;
          setListLoading({ ...loading });
        })();

        // Top 10 tỉnh thành có số lượng khách hàng cao nhất
        (async () => {
          await getListTop10CustomerProvince(plantCode);
          loading.chartTop10TinhCoKHCaoNhat = false;
          setListLoading({ ...loading });
        })();

        // Tỉ lệ khách hàng theo khu
        (async () => {
          await getListPercentCustomerSaleOffice(plantCode);
          loading.chartTiLeKHTheoKhuVuc = false;
          setListLoading({ ...loading });
        })();

        // Số lượng khách hàng theo khu vực
        (async () => {
          await getListNumberCustomerSaleOffice(plantCode);
          loading.chartSLKHTheoKhuVuc = false;
          setListLoading({ ...loading });
        })();




        // Số lượng KH thăm npp/srnq tháng này và tháng trước
        (async () => {
          await getListCustomerVisitingDistributers(plantCode);
          loading.chartSLKHThamNPP = false;
          setListLoading({ ...loading });
        })();

        // Số lượng khách hàng thăm showroom tháng này và tháng trước
        (async () => {
          await getListCustomerVisitingShowroom(plantCode);
          loading.chartSLKHThamShowroom = false;
          setListLoading({ ...loading });
        })();

        // Tổng hợp thị hiếu sản
        (async () => {
          await getListStatisticLikeView(plantCode);
          loading.chartTongHopThiHieuSP = false;
          setListLoading({ ...loading });
        })();

        // Tổng hợp điểm trưng bày
        (async () => {
          await getListShowroom(plantCode);
          loading.chartTongHopDiemTrungBay = false;
          setListLoading({ ...loading });
        })();

        // Tổng hợp xử lý khiếu nại theo nhóm hàng
        (async () => {
          await getListProductIssueGroup(plantCode);
          loading.chartTHXuLyKhieuNaiTheoNhom = false;
          setListLoading({ ...loading });
        })();

        // Tổng hợp xử lý khiếu nại lỗi thường gặp
        (async () => {
          await getListProductIssueError(plantCode);
          loading.chartTHXuLyKhieuNaiLoi = false;
          setListLoading({ ...loading });
        })();

        // Thị hiếu khách hàng đến showroom
        (async () => {
          await getListCustomerTastes(plantCode);
          loading.chartTHKHDenShowroom = false;
          setListLoading({ ...loading });
        })();

        // Tổng hợp xuất nhập tồn catalog
        (async () => {
          await getListCatalog(plantCode);
          loading.chartTonCatalog = false;
          setListLoading({ ...loading });
        })();

        //===========================THÔNG TIN CẬP NHẬT============//
        (async () => {
          await getListUpdateInformation();
          loading.bangTin = false;
          setListLoading({ ...loading });
          await getListSelectCommonDate();
        })();

        //============================BẢNG TIN=================//
        (async () => {
          await getListNewsView(accountId);
          loading.thongTinCapNhat = false;
          setListLoading({ ...loading });
        })();

        //============================CÔNG VIỆC ĐƯỢC PHÂN CÔNG=========//
        (async () => {
          await getListCountTaskToDo(employeeCode);
          await getListCountTaskProcessing(employeeCode);
          await getListCountTaskExpired(employeeCode);
          await getListCountTaskCompleted(employeeCode);
          loading.congViecPhanCong = false;
          setListLoading({ ...loading });
        })();
      };

      if (searchParams.get('lang')) {
        try {
          translateLanguage();
        } catch (error) {
          console.error(error);
        }
      } else {
        if (isShowDashboard) loadData()
      };
    }, []);

    useEffect(() => {
      const loadData = async () => {
        //============CẬP NHẬT HOẠT ĐỘNG============//
        await getListCountVisiting(selectCommonDate);
        await getListCountVisitingCustomer(selectCommonDate);
        await getListCountActivities(selectCommonDate);
      };
      if (isShowDashboard) {
        loadData();
      }
    }, [selectCommonDate]);


    // lấy nhóm chức năng từ trong local

    let groupFunc = [] as ModuleModel[];
    try {
      const user = getUserSession() as User;
      groupFunc = user.webPermission.moduleModel.splice(0, 6);
    } catch (error) {
      console.error(error);
    }

    const listIcons = [
      <Icon.Project className={`${uiStore.theme.name === 'gray' ? '!fill-[#354A5F]' : '!fill-[#02A886]'}`} />,
      <Icon.CustomerCircle className={`${uiStore.theme.name === 'gray' ? '!fill-[#354A5F]' : '!fill-[#2261BE]'}`} />,
      <Icon.Project className={`${uiStore.theme.name === 'gray' ? '!fill-[#354A5F]' : '!fill-[#2AB2C0]'}`} />,
      <Icon.FolderOpen className={`${uiStore.theme.name === 'gray' ? '!fill-[#354A5F]' : '!fill-[#CA6B8D]'}`} />,
      <Icon.TotalRevennue className={`${uiStore.theme.name === 'gray' ? '!fill-[#354A5F]' : '!fill-[#F19041]'}`} />,
      <Icon.System className={`${uiStore.theme.name === 'gray' ? '!fill-[#354A5F]' : '!fill-[#F76949]'}`} />,
    ];

    const antIcon = <LoadingOutlined style={{ fontSize: 45, color: 'black' }} spin />;

    return searchParams.get('lang') ? (
      <div className="fixed inset-0 z-50 bg-white h-screen w-full flex items-center justify-center">
        <Spin indicator={antIcon} />
      </div>
    ) : (
      <div className="px-[16px] py-[5px] flex flex-col gap-default">
        {/* Nhóm chức năng */}
        {isShowChooseModule &&
          (<div>
            <h3 className="text-textColor text-base font-semibold pt-2 uppercase ">
              {t('dashboard.function-group.title')}
            </h3>
            <div className="grid grid-cols-2 lg:grid-cols-6 gap-default">
              {groupFunc.map((items, index) => (
                <div key={index} className="bg-white h-[140px] rounded-[3px] shadow-box">
                  <Link
                    to={'/Module/' + items.moduleId}
                    // href={MVC_URL + 'Module/adae6077-4a44-480e-94bd-f5bfd92d5af2'}
                    className="w-full h-full flex flex-col justify-center items-center gap-[7px]"
                  >
                    {/* <Icon.System className={`${uiStore.theme.name === 'gray' ? '!fill-[#354A5F]' : '!fill-[#F76949]'}`} /> */}
                    {listIcons[index]}
                    <span className="text-sm font-semibold text-dark capitalize">{items.moduleName}</span>
                  </Link>
                </div>
              ))}
            </div>
          </div>
          )}
        {/* Thay đổi theme */}
        <ThemeConfig />



        {isShowDashboard && <>
          {/* Bảng thông tin */}
          <div className="">
            {/* title */}
            <h3 className="text-textColor text-base font-semibold uppercase">{t('dashboard.news-board.title')}</h3>
            {/* content */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-default">
              <CardDashBoard
                title={t('dashboard.news-board.item-1.title')}
                value={sFormatNumber(Number(listCountCustomer))}
                description={t('dashboard.news-board.item-1.description')}
                color="bg-[#E76F51]"
                colorDark="bg-[#2667B2]"
                colorLight="bg-[#2096EF]"
                icon={Icon.Team}
              />
              <CardDashBoard
                title={t('dashboard.news-board.item-2.title')}
                value={sFormatNumber(Number(listCountContact))}
                description={t('dashboard.news-board.item-2.description')}
                color="bg-[#F4A261]"
                colorDark="bg-[#09CCC4]"
                colorLight="bg-[#F4A261]"
                icon={Icon.IdCard}
              />
              <CardDashBoard
                title={t('dashboard.news-board.item-3.title')}
                value={sFormatNumber(Number(listCountTask))}
                description={t('dashboard.news-board.item-3.description')}
                color="bg-[#77BFA3]"
                colorDark="bg-[#8667D3]"
                colorLight="bg-[#5B6BC1]"
                icon={Icon.Phone}
              />
            </div>
          </div>

          {/* Chart */}
          <div className="grid lg:grid-cols-2 gap-default">
            {/* Tỉ lệ khách hàng theo loại */}
            <CollapseWrapper title={t('dashboard.chart.title-1')}>
              <Spin spinning={listLoading.chartTiLeKHTheoLoai}>
                <CustomPie
                  data={listCustomerType}
                  color={uiStore.theme.name === 'gray' ? ['#2667B2', '#12CFC7'] : ['#337AB7', '#FA6342']}
                />
              </Spin>
            </CollapseWrapper>
            {/* Tỉ lệ khách hàng theo nhóm */}
            <CollapseWrapper title={t('dashboard.chart.title-2')}>
              <Spin spinning={listLoading.chartTiLeKHTheoNhom}>
                <CustomPie
                  data={listPercentCustomerGroup}
                  legendLayout="horizontal"
                  color={
                    uiStore.theme.name === 'gray'
                      ? [
                        '#8C506D',
                        '#975F93',
                        '#8D71D3',
                        '#FFACA9',
                        '#B9B597',
                        '#666666',
                        '#276465',
                        '#598763',
                        '#809E57',
                        '#2667B2',
                        '#23CDC6',
                        '#5FC3FF',
                        '#BFBBBB',
                      ]
                      : [
                        '#6675C7',
                        '#337AB7',
                        '#25AFC8',
                        '#7ECFB6',
                        '#8CC470',
                        '#E9C46A',
                        '#FECB44',
                        '#F4975C',
                        '#FA6342',
                        '#9B2226',
                        '#A35773',
                        '#9A61B4',
                        '#BFBBBB',
                      ]
                  }
                />
              </Spin>
            </CollapseWrapper>
            {/* Số lượng nhóm khách hàng theo nhóm */}
            <CollapseWrapper title={t('dashboard.chart.title-3')}>
              <Spin spinning={listLoading.chartSLNhomKHTheoNhom}>
                <div className="h-[400px]">
                  <CustomBar
                    data={[
                      {
                        name: t('dashboard.chart.customer-number'),
                        total: listNumberCustomerGroup?.total,
                      },
                    ]}
                    label={listNumberCustomerGroup?.name}
                    rotateLabel
                    className={'!h-full'}
                  />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-4')}>
              <Spin spinning={listLoading.chartTop10TinhCoKHCaoNhat}>
                <div className="h-[400px]">
                  <CustomBarRace data={[listTop10CustomerProvince]} className={'!h-full'} />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-5')}>
              <Spin spinning={listLoading.chartTiLeKHTheoKhuVuc}>
                <CustomPie
                  data={listPercentCustomerSaleOffice}
                  color={
                    uiStore.theme.name === 'gray'
                      ? ['#1899BF', '#04C599', '#8D71D3', '#809E57']
                      : uiStore.theme.name === 'green'
                        ? ['#1899BF', '#04C599', '#FBCD54', '#F76949']
                        : ['#5B6BC1', '#1BB192', '#FBCD54', '#F76949']
                  }
                />
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-6')}>
              <Spin spinning={listLoading.chartSLKHTheoKhuVuc}>
                <CustomBar
                  data={[
                    {
                      name: t('dashboard.chart.customer-of-area'),
                      total: listNumberCustomerSaleOffice?.total,
                    },
                  ]}
                  label={listNumberCustomerSaleOffice?.name}
                  valueName={valueName[0]}
                  color={['#0BA396']}
                  className={'!h-full'}
                />
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-7')}>
              <Spin spinning={listLoading.chartSLKHThamNPP}>
                <div className="h-[363px]">
                  <CustomBarRace
                    data={listCustomerVisitingDistributers}
                    color={['#1899BF', '#6BF3E3']}
                    className={'!h-full'}
                  />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-8')}>
              <Spin spinning={listLoading.chartSLKHThamShowroom}>
                <div className="h-[363px]">
                  <CustomBarRace
                    data={listCustomerVisitingShowroom}
                    color={['#5E548E', '#BE95C4']}
                    className={'!h-full'}
                  />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-9')}>
              <Spin spinning={listLoading.chartTongHopThiHieuSP}>
                <div className="h-[363px]">
                  <CustomBarRace data={[listStatisticLikeView]} color={['#8B5A90', '#BE95C4']} className={'!h-full'} />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-10')}>
              <Spin spinning={listLoading.chartTongHopDiemTrungBay}>
                <div className="h-[363px]">
                  <CustomMixedLineAndBar
                    data={listShowroom}
                    color={uiStore.theme.name === 'blue' ? ['#126DAE', '#F3974B'] : ['#3CA1BA', '#F3974B']}
                    rotateLabel
                    valueName={t('dashboard.chart.point')}
                    className={'!h-full'}
                  />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-11')}>
              <Spin spinning={listLoading.chartTHXuLyKhieuNaiTheoNhom}>
                <div className="h-[458px]">
                  <CustomMixedLineAndBar
                    data={listProductIssueGroup}
                    color={['#42C4D2', '#F3974B']}
                    rotateLabel
                    valueName={t('dashboard.chart.case')}
                    className={'!h-full'}
                  />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-12')}>
              <Spin spinning={listLoading.chartTHXuLyKhieuNaiLoi}>
                <div className="h-[458px]">
                  <CustomMixedLineAndBar
                    data={listProductIssueError}
                    smooth
                    color={['#825CC0', '#1FB5AD']}
                    rotateLabel
                    valueName={t('dashboard.chart.case')}
                    className={'!h-full'}
                  />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-13')}>
              <Spin spinning={listLoading.chartTHKHDenShowroom}>
                <div className="h-[363px]">
                  <CustomBarRace
                    data={[listCustomerTastes]}
                    className={'!h-full'}
                    color={
                      uiStore.theme.name === 'green'
                        ? ['#3C6E71']
                        : uiStore.theme.name === 'gray'
                          ? ['#2667B2']
                          : ['#5470C6']
                    }
                  />
                </div>
              </Spin>
            </CollapseWrapper>
            <CollapseWrapper title={t('dashboard.chart.title-14')}>
              <Spin spinning={listLoading.chartTonCatalog}>
                <div className="h-[363px]">
                  <CustomBarRace
                    data={[listCatalog]}
                    className={'!h-full'}
                    color={
                      uiStore.theme.name === 'green'
                        ? ['#AA4466']
                        : uiStore.theme.name === 'gray'
                          ? ['#809E57']
                          : ['#AA4466']
                    }
                  />
                </div>
              </Spin>
            </CollapseWrapper>
          </div>

          {/* Cập nhật hoạt động */}
          <div className="">
            {/* title */}
            <div className="lg:flex justify-between mb-2.5 items-center">
              <h3 className="text-textColor text-title font-semibold uppercase">{t('dashboard.activity.title')}</h3>
              <CustomSelect
                defaultValue="Tháng này"
                options={listSelectCommonDate}
                onChange={handleSelectCommonDate}
                className={'!min-w-[240px]'}
              />
            </div>
            {/* content */}
            <div className="grid lg:grid-cols-3 gap-default">
              <a href={MVC_URL + 'Customer/Appointment'}>
                <CardDashBoard
                  title={t('dashboard.activity.item-1.title')}
                  value={String(listCountVisiting)}
                  description={t('dashboard.activity.item-1.description')}
                  color="bg-[#1EBD9B]"
                  colorDark="bg-[#8667D3]"
                  colorLight="bg-[#02A886]"
                  icon={Icon.Team}
                />
              </a>
              <a href={MVC_URL + 'Work/Task?Type=THKH'}>
                <CardDashBoard
                  title={t('dashboard.activity.item-2.title')}
                  value={String(listCountVisitingCustomer)}
                  description={t('dashboard.activity.item-2.description')}
                  color="bg-[#4074B5]"
                  colorDark="bg-[#4074B5]"
                  colorLight="bg-[#4074B5]"
                  icon={Icon.Customer}
                />
              </a>
              <a href={MVC_URL + 'Work/Task?Type=ACTIVITIES'}>
                <CardDashBoard
                  title={t('dashboard.activity.item-3.title')}
                  value={String(listCountActivities)}
                  description={t('dashboard.activity.item-3.description')}
                  color="bg-[#F76949]"
                  colorDark="bg-[#09CCC4]"
                  colorLight="bg-[#F76949]"
                  icon={Icon.Mission}
                />
              </a>
            </div>
          </div>
          {/* Cập nhật hoạt động 2*/}
          <div className="">
            <div className="grid lg:grid-cols-3 gap-default">
              {/* Thông tin cập nhật */}

              <Spin spinning={listLoading.thongTinCapNhat}>
                <div className="bg-white rounded-[3px] shadow-box relative pb-[41px]">
                  <div className="border-b border-dashed min-w-[46px] py-3 px-4">
                    <h3 className="text-base font-semibold text-textColor m-0">
                      {t('dashboard.activity.item-4.title')} ({`${sFormatNumber(listUpdateInformation?.total)}`})
                    </h3>
                  </div>
                  <div className="px-4 min-h-[230px]">
                    {listUpdateInformation?.listTasks.map((item) => (
                      <div
                        className="border-b border-solid min-w-[59px] pt-[17px] text-[#0070B1] text-xs"
                        key={item.taskId}
                      >
                        <a href={MVC_URL + 'Work/Task/Edit/' + `${item.taskId}`}>
                          <div className="flex items-center gap-2">
                            <span>
                              <Icon.ClipboardListCircle
                                className={`${uiStore.theme.name === 'gray'
                                  ? '!fill-[#4074B5]'
                                  : uiStore.theme.name === 'green'
                                    ? '!fill-[#00708D]'
                                    : '!fill-[#2261BE]'
                                  }`}
                              />
                            </span>
                            <span className="clamp-1 text-primary">
                              ({`${item.workFlowCode}`}) {`${item.summary}`}
                            </span>
                          </div>
                          <div className="w-full text-end text-lightText">{`${moment(item.createTime).format(
                            'DD/MM/YYYY HH:mm:ss',
                          )}`}</div>
                        </a>
                      </div>
                    ))}
                  </div>
                  <div className="w-full absolute bottom-0 left-0 pt-[7px] pb-[12px] px-4 min-h-[41px] text-primary/90 text-xs">
                    <div className="w-full text-end text-lightText ">
                      <Link to="" className="inline-flex items-center gap-[10px] ">
                        <span className="text-primary/70 leading-[22px] text-xs font-semibold">{t('btn.see-more')}</span>
                        <span>
                          <Icon.ArrowDown
                            width="11"
                            height="14"
                            className={`${uiStore.theme.name === 'gray'
                              ? '!fill-[#4074B5]'
                              : uiStore.theme.name === 'green'
                                ? '!fill-[#00708D]'
                                : '!fill-[#2261BE]'
                              } -rotate-90`}
                          />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </Spin>
              {/* Bảng tin */}
              <Spin spinning={listLoading.bangTin}>
                <div className="bg-white rounded-[3px] shadow-box relative pb-[41px]">
                  <div className="border-b border-dashed min-w-[46px] py-3 px-4">
                    <h3 className="text-base font-semibold text-textColor m-0">{t('dashboard.activity.item-5.title')}</h3>
                  </div>
                  <div className="px-4 min-h-[230px]">
                    {listNewsView?.map((item) => (
                      <div
                        className="border-b border-solid min-w-[59px] pt-[17px] text-[#0070B1] text-xs"
                        key={item.newsId}
                      >
                        <a href={MVC_URL + 'MasterData/News/Detail/' + `${item.newsId}`}>
                          <div className="flex items-center gap-2">
                            <span>
                              <Icon.NewCircle
                                className={`${uiStore.theme.name === 'gray'
                                  ? '!fill-[#4074B5]'
                                  : uiStore.theme.name === 'green'
                                    ? '!fill-[#00708D]'
                                    : '!fill-[#2261BE]'
                                  }`}
                              />
                            </span>
                            <span className="text-primary">{`${item.title}`}</span>
                          </div>
                          <div className="w-full text-end text-lightText">{`${item.createTime}`}</div>
                        </a>
                      </div>
                    ))}
                  </div>
                  <div className="w-full absolute bottom-0 left-0 pt-[7px] pb-[12px] px-4 min-h-[41px] text-primary/90 text-xs">
                    <div className="w-full text-end text-lightText ">
                      <Link to="" className="inline-flex items-center gap-[10px] text-[#0070B1] leading-[22px]">
                        <span className="text-primary/70 leading-[22px] text-xs font-semibold">{t('btn.see-more')}</span>
                        <span>
                          <Icon.ArrowDown
                            width="11"
                            height="14"
                            className={`${uiStore.theme.name === 'gray'
                              ? '!fill-[#4074B5]'
                              : uiStore.theme.name === 'green'
                                ? '!fill-[#00708D]'
                                : '!fill-[#2261BE]'
                              } -rotate-90`}
                          />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </Spin>
              {/* Công việc được phân công */}
              <Spin spinning={listLoading.congViecPhanCong}>
                <div className="bg-white rounded-[3px] shadow-box">
                  <div className="border-b border-dashed min-w-[46px] py-3 px-4">
                    <h3 className="text-base font-semibold text-textColor m-0">{t('dashboard.activity.item-6.title')}</h3>
                  </div>
                  <div className="px-4 py-[12px] grid grid-cols-2 gap-default">
                    <a href={MVC_URL + 'Work/Task?Type=MyWork&tab=tab-kanban'}>
                      <div
                        className={`${uiStore.theme.name === 'gray'
                          ? 'bg-[#E3EFFA]'
                          : uiStore.theme.name === 'green'
                            ? 'bg-[#E6F4F5]'
                            : 'bg-[#E6F4F5]'
                          } min-h-[113px] rounded pb-[11px] pt-[11px] pl-4 pr-[11px]`}
                      >
                        <div className="flex justify-between items-start">
                          <div className="text-4xl font-medium text-black">{`${listCountTaskToDo}`}</div>
                          <div>
                            <Icon.ListBoardPencilCircle
                              className={`${uiStore.theme.name === 'gray'
                                ? '!fill-[#427CAC]'
                                : uiStore.theme.name === 'green'
                                  ? '!fill-[#0087A9]'
                                  : '!fill-[#2261BE]'
                                }`}
                            />
                          </div>
                        </div>
                        <div className="text-base min-h-[38px] text-[#1A1A1A] flex items-center mt-[6px]">
                          <span>{t('dashboard.activity.item-6.description-1')}</span>
                        </div>
                      </div>
                    </a>
                    <a href={MVC_URL + 'Work/Task?Type=MyWork&tab=tab-kanban&TaskProcessCode_Input=Processing'}>
                      <div
                        className={`${uiStore.theme.name === 'gray' ? 'bg-[#E9F8D6]' : 'bg-[#EBFFE1]'
                          } min-h-[113px] rounded pb-[11px] pt-[11px] pl-4 pr-[11px]`}
                      >
                        <div className="flex justify-between items-start">
                          <div className="text-4xl font-medium text-black">{`${listCountTaskProcessing}`}</div>
                          <div>
                            <Icon.RotateCircle
                              className={`${uiStore.theme.name === 'gray' ? '!fill-[#809E57]' : '!fill-[#9FBD39]'}`}
                            />
                          </div>
                        </div>
                        <div className="text-base min-h-[38px] text-[#1A1A1A] flex items-center mt-[6px]">
                          <span>{t('dashboard.activity.item-6.description-2')}</span>
                        </div>
                      </div>
                    </a>
                    <a href={MVC_URL + 'Work/Task?Type=MyWork&tab=tab-kanban&TaskProcessCode_Input=Expired'}>
                      <div
                        className={`${uiStore.theme.name === 'gray' ? 'bg-[#DDF8F6]' : 'bg-[#FFF2E8]'
                          } min-h-[113px] rounded pb-[11px] pt-[11px] pl-4 pr-[11px]`}
                      >
                        <div className="flex justify-between items-start">
                          <div className="text-4xl font-medium text-black">{`${listCountTaskExpired}`}</div>
                          <div>
                            <Icon.ListTimeCircle
                              className={`${uiStore.theme.name === 'gray' ? '!fill-[#12CFC7]' : '!fill-[#FF8811]'}`}
                            />
                          </div>
                        </div>
                        <div className="text-base min-h-[38px] text-[#1A1A1A] flex items-center mt-[6px]">
                          <span>{t('dashboard.activity.item-6.description-3')}</span>
                        </div>
                      </div>
                    </a>
                    <a href={MVC_URL + 'Work/Task?Type=MyWork&tab=tab-kanban&TaskProcessCode_Input=CompletedOnTime'}>
                      <div
                        className={`${uiStore.theme.name === 'gray' ? 'bg-[#E9E3FA]' : 'bg-[#E0FCF6]'
                          } min-h-[113px] rounded pb-[11px] pt-[11px] pl-4 pr-[11px]`}
                      >
                        <div className="flex justify-between items-start">
                          <div className="text-4xl font-medium text-black">{`${listCountTaskCompleted}`}</div>
                          <div>
                            <Icon.CheckCircle
                              className={`${uiStore.theme.name === 'gray' ? '!fill-[#8667D3]' : '!fill-[#3DA758]'}`}
                            />
                          </div>
                        </div>
                        <div className="text-base min-h-[38px] text-[#1A1A1A] flex items-center mt-[6px]">
                          <span>{t('dashboard.activity.item-6.description-4')}</span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </Spin>
            </div>
          </div>
        </>}


        {/* kiểm tra xem có xài chat box không */}
        {
          getIsChatBox() ? <>
            {/* Zapier Chatbox */}
            <zapier-interfaces-chatbot-embed
              is-popup="true"
              chatbot-id="cmbrk00ai006k12v3jfk9x5cz"
            ></zapier-interfaces-chatbot-embed>
          </> : <></>
        }

      </div>
    );
  });
}
